import { Component, Input, OnInit } from '@angular/core';
import { ModalController, ToastController } from '@ionic/angular';

@Component({
  selector: 'app-hampers-item',
  templateUrl: './hampers-item.component.html',
  styleUrls: ['./hampers-item.component.scss'],
})
export class HampersItemComponent implements OnInit {
  @Input() hamperList: any[];
  @Input() selectedHampers:any[];
  @Input() mstProductList :any[];
  @Input() productGimmickList :any[];
  @Input() hampersId :any=0;
  @Input() hampersCode:any='';
  @Input() action:any;
  @Input() index:any;
  @Input() promoStock:any;
  @Input() regulerStock:any;
  
  DECIMAL_SEPARATOR:any=".";
  GROUP_SEPARATOR:any=",";
  productList: any[] = [];
  displayProductList:any[]=[];

  hampersName:any='';
  selectableItem:any=[];
  selectableFreeItem:any=[];
  hampersQty:any=0;
  hampersQtyWithSeparator:any='';
  itemInSelectedHampers:any = '';
  hampersPrice:any=0;
  jumlahBarisIsiHampers=0;
  constructor(
    private modalController:ModalController,
    private toastCtrl:ToastController
  ) { }

  ngOnInit() {
  }

  ionViewDidEnter() {
    if(this.action=='e'){
      let findHampers = this.selectedHampers[this.index];
      this.hampersQty = 0;
      this.displayProductList = [];
      if(findHampers){
        this.hampersQty =findHampers.qty;
        this.itemInSelectedHampers =findHampers.product_list;
        this.getHampersById(this.hampersId.id)
        this.productList = this.itemInSelectedHampers;
        const parts = this.unFormat(String(this.hampersQty)).split(this.DECIMAL_SEPARATOR);
        this.hampersQtyWithSeparator  = parts[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, this.GROUP_SEPARATOR) + (!parts[1] ? '' : this.DECIMAL_SEPARATOR + parts[1]);
        if(this.productList.length>0){
          for(let p=0;p<this.productList.length;p++){
            let product_id = this.productList[p].id;
            let qty = this.productList[p].qty;
            let checkDisplay = this.displayProductList.find(x=>x.id==product_id);
            if(checkDisplay==undefined){
              this.displayProductList.push({ ...this.productList[p] });
            }
            else{
              checkDisplay.qty+=qty;
            }
            let promotion_detail_id = this.productList[p].promotion_detail_id;
            if(this.productList[p].product_type=='free'){
              let findmaster = this.selectableFreeItem.find(x=>x.product_id==product_id && x.promotion_detail_id ==promotion_detail_id);
              if(findmaster){
                findmaster.quantity_input = qty;
              }
            }
            else if(this.productList[p].product_type=='reguler'){
              let findmaster = this.selectableItem.find(x=>x.product_id==product_id && x.promotion_detail_id ==promotion_detail_id);
              if(findmaster){
                findmaster.quantity_input = qty;
              }
            }
          }
        }
      }
    }
  }

  async dismissModal() {
    await this.modalController.dismiss('');
  }
  setHampersId(event){
    this.getHampersById(event.value.id)
  }

  getHampersById(hampersId:any){
    this.productList = [];
    let findIsiHamper = this.hamperList.find(x=>x.id==hampersId);
    this.selectableItem = [];
    this.selectableFreeItem = [];
    this.jumlahBarisIsiHampers = 0;
    if(findIsiHamper){
      this.hampersName = findIsiHamper.promotion_name;
      this.hampersPrice = findIsiHamper.hamper_price;
      this.hampersCode = findIsiHamper.hamper_code;
      let product_required = findIsiHamper.product_required;
      let free_item = findIsiHamper.free_item;
      const uniqueIds: string[] = [];
      if(product_required.length>0){
        for(let pr =0;pr < product_required.length;pr++){
          let stock =0;
          let qty = product_required[pr].qty;
          let qty_type = product_required[pr].qty_type;
          this.jumlahBarisIsiHampers+=parseInt(qty);
          let warehouse_id =0;
          if(product_required[pr].product_id!=''){
            product_required[pr].product_id.split(';').forEach(item => {
            if (item.trim() !== '') {
              let cariProduct =this.mstProductList[parseInt(item.trim())] ;
              let productName ='';
              let price =0;
              if(cariProduct !== undefined){
                productName=cariProduct.product_name;
                price=cariProduct.price;
                let checkStock:any = this.regulerStock.find(x => x.product_id === cariProduct.id);
                if (checkStock) {
                  stock = checkStock.stock;
                  warehouse_id = checkStock.warehouse_id;
                }
              }
              let isChecked =false;
              if(this.action=='e'){
                if(this.itemInSelectedHampers.find(x=>x.id==item.trim() && x.promotion_detail_id==pr)){
                  isChecked =true;
                }
              }
              this.selectableItem.push({
                promotion_detail_id:pr,
                product_id:item.trim(),
                product_name:productName,
                isChecked:isChecked,
                stock:stock,
                qty:qty,
                price:price,
                qty_type:qty_type,
                tipe:'reguler',
                warehouse_id:warehouse_id
              })
            }
          });
         }
        }
      }
      if(free_item.length>0){
        for(let fi=0;fi<free_item.length;fi++){
          let stock:number=0;
          let warehouse_id =0;
          const id = free_item[fi].promotion_detail_id;
          let qty = free_item[fi].qty;
          let qty_type = free_item[fi].qty_type;
          if (uniqueIds.indexOf(id) === -1) {
            uniqueIds.push(id);
            this.jumlahBarisIsiHampers+=parseInt(qty);
          }
          let cariProduct =this.productGimmickList.find(x=>x.id==free_item[fi].product_id);
          let productName ='';
          if(cariProduct){
            productName=cariProduct.product_name;
            let checkStock:any = this.promoStock.find(x => x.product_id === cariProduct.id);
            if (checkStock) {
              stock = checkStock.stock;
              warehouse_id = checkStock.warehouse_id;
            }
          }
          else{
            let cariProduct =this.mstProductList[parseInt(free_item[fi].product_id)];
            if(cariProduct){
              productName=cariProduct.product_name;
              let checkStock:any = this.promoStock.find(x => x.product_id === cariProduct.id);
              if (checkStock) {
                stock = checkStock.stock;
                warehouse_id = checkStock.warehouse_id;
              }
            }
          }
          let isChecked =false;
          if(this.action=='e'){
            if(this.itemInSelectedHampers.find(x=>x.id==free_item[fi].product_id && x.promotion_detail_id==free_item[fi].promotion_detail_id)){
              isChecked =true;
            }
          }
          this.selectableFreeItem.push({
            promotion_detail_id:free_item[fi].promotion_detail_id,
            product_id:free_item[fi].product_id,
            product_name:productName,
            isChecked:isChecked,
            stock:stock,
            qty:qty,
            price:0,
            qty_type:qty_type,
            tipe:'free',
            warehouse_id:warehouse_id
          })
        }
      }
    }
  }
  checkStock(p: any, event: any) {
    let qtyWithSeparator = String(event.detail.value).replace(/[^0-9]/g, '');
    let inputValue =parseInt(qtyWithSeparator);
    let totalQty =0;
    // Jika input kosong atau bukan angka, set ke 0
    if (!event.detail.value || inputValue==0) {
      p.quantity = 0;
      event.target.value = 0;
      this.updateList();
    }
    let quantity = Number(inputValue);
    let maxInput =p.qty;
    if(p.qty_type=='1'){// klau qty type gabungan maka jumlah yg udah ada
      totalQty = this.productList
      .filter(pl => pl.promotion_detail_id == parseInt(p.promotion_detail_id))
      .reduce((sum, pl) => sum + Number(pl.qty), 0);
    }
    else{//cari produk nya udah ada belum
      let cariExisting = this.productList.find(x=>x.promotion_detail_id==parseInt(p.promotion_detail_id) && x.id!=p.product_id);
      if(cariExisting){
        maxInput=0;
      }
    }
    const maxAllowed = Math.min(p.stock, maxInput);
    if(totalQty>maxInput){
      quantity = 0;
    }
    else{
      if (quantity > maxAllowed) {
        quantity = maxAllowed;
      } 
      else if (quantity < 0) {
        quantity = 0;
      }
    } 

    const parts = this.unFormat(String(quantity)).split(this.DECIMAL_SEPARATOR);
    let quantityWithSeparator = parts[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, this.GROUP_SEPARATOR) + (!parts[1] ? '' : this.DECIMAL_SEPARATOR + parts[1]);
    if (inputValue === 0|| inputValue === null || isNaN(Number(inputValue))) {
      inputValue = 0; // jadikan 0 default
      event.target.value = 0;
    }
    else{
      event.target.value = quantityWithSeparator;
    }
    // ===========================
    // HANDLE ADD / UPDATE / REMOVE
    // ===========================
    let existing = this.productList.find(x => x.id == p.product_id && x.promotion_detail_id==parseInt(p.promotion_detail_id));
    if (quantity > 0) {      
        if (existing) {
        // ✅ Update quantity kalau produk sudah ada
        existing.qty = quantity;
      } else {
        // ✅ Tambahkan produk baru
        this.chooseProduct(p.product_id, p.tipe, p.stock, quantity,parseInt(p.promotion_detail_id));
      }
    } else {
      // ✅ Hapus produk dari list kalau quantity = 0
      if (existing) {
        existing.qty = quantity;
       // this.productList = this.productList.filter(x => x.id !== p.product_id && x.promotion_detail_id==parseInt(p.promotion_detail_id));
      }
      this.updateList()
    }
  }
  chooseProduct(productId: any,productType:any,stock,quantity_input:any,promotion_detail_id:any) {
    if(productId !== '' && productId !== undefined) {
      let checkItemPcode: any[] = this.productList.find(x => x.id === productId  && x.promotion_detail_id==promotion_detail_id);
      if (checkItemPcode === undefined) {
        let findProduct :any= null;
        if(productType=='reguler'){
          findProduct = this.selectableItem.find(x=>x.product_id==productId.toString() && x.promotion_detail_id==promotion_detail_id);
        }
        else{
          findProduct = this.selectableFreeItem.find(x=>x.product_id==productId.toString() && x.promotion_detail_id==promotion_detail_id);
        }
        if(findProduct){
          this.productList.push({
            id: findProduct.product_id,
            barcode: findProduct.barcode,
            product_name: findProduct.product_name,
            qty:quantity_input,
            price:findProduct.price,
            product_type:productType,
            promotion_detail_id:promotion_detail_id,
            stock:stock,
            warehouse_id:findProduct.warehouse_id
          });
        }
      } else {
        this.toastCtrl.create({ duration: 2000, message: 'Product sudah ada di list!' }).then(t => t.present());
      }
      this.updateList();
    }
  }

  updateList(){
    if(this.productList.length>0){
      this.displayProductList=[];
      this.productList = this.productList.filter(x=>x.qty>0);
      for(let p=0;p<this.productList.length;p++){
        let product_id = this.productList[p].id;
        let qty = this.productList[p].qty;
        let checkDisplay = this.displayProductList.find(x=>x.id==product_id);
        if(checkDisplay==undefined){
          this.displayProductList.push({ ...this.productList[p] });
        }
        else{
          checkDisplay.qty+=qty;
        }
      }
    }
  }

  async chooseHamper() {
    const totalQty = this.productList
      .reduce((sum, pl) => sum + Number(pl.qty), 0);
    if(this.hampersQty==0 || this.hampersId=='' || this.hampersId==0 || this.productList.length==0 || this.jumlahBarisIsiHampers!=totalQty){
      let msg ='';
      if(this.hampersId==0 || this.hampersId==''){
        msg+= 'Hampers, ';
      }
      if(this.hampersQty==0){
        msg+= 'Qty Hampers, ';
      }
      if(this.productList.length==0){
        msg+= 'Isi Hampers, ';
      }
      if(this.hampersId==0 || this.hampersId=='' || this.hampersQty==0 || this.productList.length==0){
        msg+=' harus diisi!';
      }
      if( this.jumlahBarisIsiHampers!=totalQty){        
        msg+= 'Jumlah produk dalam hampers belum sesuai. Harap dilengkapi';
      }
      await this.toastCtrl.create({ duration: 2000, message: msg }).then(t => t.present());
    }
    else {
      //cek stok apakah cukup
      let stockKurang = 0;
      for(let i=0;i<this.productList.length;i++){
        let hitung = this.productList[i].qty * this.hampersQty;
        let stock = this.productList[i].stock;
        if(hitung>stock){
          stockKurang++;
        }
      }
      if(stockKurang>0){
        await this.toastCtrl.create({ duration: 2000, message: "Stock Tidak Cukup, Mohon periksa kembali" }).then(t => t.present());
      }
      else{
        let data = {
          productList:this.productList,
          hampersCode:this.hampersCode,
          hampersId:this.hampersId,
          hampersName:this.hampersName,
          hampersQty:this.hampersQty,
          hampersPrice:this.hampersPrice,
        }
        await this.modalController.dismiss(data);
      }
    }
  }

  unFormat(val) {
    if (!val) {
      return '';
    }
    val = val.replace(/^0+/, '');
    if (this.GROUP_SEPARATOR === ',') {
      return val.replace(/,/g, '');
    } else {
      return val.replace(/\./g, '');
    }
  }

  numberOnlyValidation(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  getChangeHamperQty() {
    if(this.hampersQtyWithSeparator!='0' && this.hampersQtyWithSeparator!='' && this.hampersQtyWithSeparator!=null){
      const parts = this.unFormat(String(this.hampersQtyWithSeparator)).split(this.DECIMAL_SEPARATOR);
      this.hampersQtyWithSeparator = parts[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, this.GROUP_SEPARATOR) + (!parts[1] ? '' : this.DECIMAL_SEPARATOR + parts[1]);
      let hampersQtyWithSeparator = String(this.hampersQtyWithSeparator).replace(/[^0-9]/g, '');
      this.hampersQty =parseInt(hampersQtyWithSeparator);
    }
    else{
      this.hampersQtyWithSeparator='0';
      this.hampersQty =0;
    }
  }
}